import { ICommonObjectProps } from './common';

export enum PAYMENT_FISERV_ERROR_VIOLATION {
  BUSINESS_RULE_VIOLATION = 'BusinessRuleViolation',
  FAILED_VALIDATION = 'FailedValidation',
}

export enum PAYMENT_FISERV_STATUS_CODE {
  UNPROCESSABLE_ENTITY = '422',
  INTERNAL_HOST_ERROR = '500',
  INVALID_DATA = '400',
}

export enum PAYMENT_FISERV_STATUS_MSG_CODE {
  PAYMENT_ACCOUNT_VELOCITY_REACHED = 'FIS201',
  FUNDING_ACCOUNT_TOKEN_EXPIRED = 'FIS202',
  INTERNAL_HOST_ERROR = 'FIS203',
  AUTOPAY_INTERNAL_HOST_ERROR = 'FIS212',
  BILLING_ACCOUNT_VELOCITY_REACHED = 'FIS204',
  BILLING_ACCOUNT_BlOCKED = 'FIS206',
  INVALID_CARD_DATA = 140,
  INVALID_BANK_DATA = 107,
  PAYMENT_ACCOUNT_BLOCKED = 137,
  PAYMENT_AUTHORIZATION_DECLINED = '121',
  INVALID_EMAIL = '102',
  INVALID_EMAIL2 = '103',
  EMAIL_INVALID_FORMAT = 'FIS213',
  EMAIL_LENGTH_VALIDATION_FAILED = 'FIS214',
  CARD_NOT_SUPPORTED = 'FIS215',
  ACCOUNT_OR_ROUTING_INVALID = 'FIS216',
  FUNDING_CARD_EXPIRED = 'FIS217',
  COMMERCIAL_FUNDING_ACCOUNT_NOT_SUPPORTED = 'FIS218',
  PAYMENT_ACCOUNT_BLOCKED_FIS = 'FIS137',
}

export const WALLET_FISERV_ERROR_CODE: ICommonObjectProps = {
  PAYMENT_METHOD_WITH_INFORMATION_EXISTS: 'ERR204',
};
